import { Helmet } from "react-helmet-async";
import { SITE } from "./site";

export const Seo = ({
  title,
  description,
  path = "/",
  type = "website",
  jsonLd,
}) => {
  const fullTitle = title
    ? `${title} | ${SITE.name}`
    : `${SITE.name} | Strategic Legal Solutions for Businesses and Individuals`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={SITE.url + path} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={SITE.url + path} />
      <meta property="og:site_name" content={SITE.name} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export const legalServiceSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LegalService",
  name: SITE.name,
  url: SITE.url,
  description:
    "Legal advisory practice in India offering corporate and commercial law, intellectual property and trademark services, contract drafting, real estate due diligence, regulatory compliance and dispute resolution support.",
  areaServed: { "@type": "Country", name: "India" },
  address: {
    "@type": "PostalAddress",
    addressCountry: "IN",
  },
});

export const articleSchema = (a) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: a.title,
  description: a.excerpt,
  datePublished: a.published_at,
  author: { "@type": "Organization", name: SITE.name },
  publisher: { "@type": "Organization", name: SITE.name },
  mainEntityOfPage: `${SITE.url}/insights/${a.slug}`,
});
